<template>
  <NuxtPwaManifest />
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import { usePrimeVue } from "primevue/config";
import translationObj from "./languages/translation.json";

const env = useRuntimeConfig();
const BASE_PROGETTO = env.public.base_progetto;
const languages = [{ value: "it" }, { value: "en" }, { value: "fr" }];

onMounted(() => {
  const primevue = usePrimeVue();
  setLanguage(primevue);
});

// onErrorCaptured((err) => {
//   alert("Errore catturato: " + err.message);
// });

function setLanguage(primevue) {
  const lang = useCookie(`i18n${BASE_PROGETTO}`).value || "it";
  const found = languages.some((l) => l.value === lang);
  setTranslations(found ? lang : "it", primevue);
}

function setTranslations(lang, primevue) {
  const translations = translationObj?.[lang];
  if (!translations) return;
  Object.assign(primevue.config.locale, translations);
}
</script>
